import type { SpaceEntry } from '../types.js'
import { generateId } from '../id.js'

export type SpaceIdentity = {
  createdId: string
  editedId: string
}

export function deriveSpaceIded(blocks: SpaceEntry[]): SpaceIdentity {
  if (!blocks.length) {
    const id = generateId()
    return { createdId: id, editedId: id }
  }

  let createdId = blocks[0].ided[0]
  let editedId = blocks[0].ided[1]

  for (const block of blocks) {
    if (block.ided[0] < createdId) createdId = block.ided[0]
    if (block.ided[1] > editedId) editedId = block.ided[1]
  }

  return { createdId, editedId }
}
